import { UI_DRAWER_VISIBILITY_CHANGED } from '../actions/index';

const initialState = {
  drawerVisibile: false,
};

export default function (state = initialState, action) {
  console.log(action);
  switch (action.type) {
    case UI_DRAWER_VISIBILITY_CHANGED:
      return Object.assign({}, state, { drawerVisibile: action.visibility });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uiState.js